/**
 * Programme un travail non urgent (chunk preload, etc.) sans bloquer le main thread.
 * Fallback setTimeout pour Safari < 17 (qui n'a pas requestIdleCallback).
 */
type IdleHandle = number;
type IdleCb = (deadline: { didTimeout: boolean; timeRemaining: () => number }) => void;

type IdleWindow = Window & {
  requestIdleCallback?: (cb: IdleCb, opts?: { timeout: number }) => IdleHandle;
  cancelIdleCallback?: (h: IdleHandle) => void;
};

export function whenIdle(cb: () => void, timeout = 2500): () => void {
  if (typeof window === "undefined") return () => undefined;
  const w = window as IdleWindow;
  if (typeof w.requestIdleCallback === "function") {
    const id = w.requestIdleCallback(() => cb(), { timeout });
    return () => w.cancelIdleCallback?.(id);
  }
  const id = window.setTimeout(cb, 200);
  return () => window.clearTimeout(id);
}
